import { render, staticRenderFns } from "./weight-icon.vue?vue&type=template&id=a6db2568&"
import script from "./weight-icon.vue?vue&type=script&lang=js&"
export * from "./weight-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports